import { IsBoolean } from "class-validator";

export class UpdatePasswordResult {
    @IsBoolean()
    success: boolean;
}